import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueMq from 'vue-mq'
import Vuelidate from 'vuelidate'

Vue.config.productionTip = false

Vue.use(VueMq, {
  breakpoints: {
    mobile: 600,
    tablet: 900,
    laptop: 1200,
    desktop: Infinity
  },
  defaultBreakpoint: 'desktop'
})

Vue.use(Vuelidate)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
